import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

export type Request = ErpRecipe;

export interface Response {
	data: string;
}

export type ErpRecipe = {
	recipeId: string;
	name: string;
	isFavorite: boolean;
	createdDateUtc: string;
	lastEditedDateUtc: string;
	mappings: Mapping[];
};

export type Mapping = {
	ingredientId: string;
	productId: string | null;
	sourceId: string | null;
	segmentIndex: number;
	name: string | null;
	imageUrl: string | null;
	price: string | null;
	gtin: string | null;
};

const ResponseDataSchema = z.string();
const validator = createValidator(ResponseDataSchema);

export async function callApi(id: string, request: Request): Promise<Optional<Response>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/erp/recipe/${id}`;
	const response = (await axios.put(url, request).toOptionalFiltered(validator)).map(
		(x) => x.data
	);
	return response;
}
